// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import permissionBtn from '@/directive/permissionBtn'
import './permission'
import './icons' // icon
import './styles/index.scss'
Vue.config.productionTip = false
Vue.directive('permission-btn', permissionBtn)
Vue.use(ElementUI)
// document.domain = '.junengcloud.com'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js